export default function WalletInputIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 11V3.00003C1 1.89545 1.89545 1.00001 3.00003 1.00002C6.33335 1.00004 9.66668 1.00001 13 1C14.1046 1 15 1.89543 15 3C15 4.10457 14.1046 5 13 5C13.5304 5 14.0391 5.21071 14.4142 5.58579C14.7893 5.96086 15 6.46957 15 7C15 8.7811 15 11.2189 15 13C15 13.5304 14.7893 14.0391 14.4142 14.4142C14.0391 14.7893 13.5304 15 13 15H5C3.93913 15 2.92172 14.5786 2.17157 13.8284C1.42143 13.0783 1 12.0609 1 11Z"
        fill="#C0C2BE"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3C1 3.53043 1.21071 4.03914 1.58579 4.41421C1.96086 4.78929 2.46957 5 3 5H13C14.1046 5 15 4.10457 15 3C15 1.89545 14.1045 1.00007 13 1.00014C10.9564 1.00026 8.91283 1.00018 6.86928 1.0001C5.57952 1.00005 4.28976 1 3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579ZM10.5858 8.58574C10.2107 8.96081 10 9.46952 10 9.99995C10 10.5304 10.2107 11.0391 10.5858 11.4142C10.9609 11.7892 11.4696 12 12 12H14.85C14.8898 12 14.9279 11.9841 14.9561 11.956C14.9842 11.9279 15 11.8897 15 11.85V8.14995C15 8.11017 14.9842 8.07202 14.9561 8.04389C14.9279 8.01575 14.8898 7.99995 14.85 7.99995H12C11.4696 7.99995 10.9609 8.21067 10.5858 8.58574Z"
        fill="#787B74"
      />
    </svg>
  );
}
